import { Link } from 'react-router-dom';

const NotAccess = () => (
  <>
    <main>
      <h1>No Access!</h1>
      <h3>you are not authorized to access this page. please contact the system administrator</h3>
      <Link to="/"> Go to Home </Link>
    </main>
  </>
);

export default NotAccess;